import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { me as fetchMe, myOrg as fetchOrg, logout as apiLogout } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [org, setOrg] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const u = await fetchMe();
      setUser(u);
      try {
        const o = await fetchOrg();
        setOrg(o);
      } catch {
        setOrg(null);
      }
    } catch {
      setUser(null);
      setOrg(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const signOut = useCallback(async () => {
    try { await apiLogout(); } catch (e) { /* network error during logout is fine */ }
    localStorage.removeItem("td_session");
    setUser(null);
    setOrg(null);
  }, []);

  return (
    <AuthCtx.Provider value={{ user, org, loading, setUser, setOrg, refresh, signOut }}>
      {children}
    </AuthCtx.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthCtx);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
